// @ts-nocheck
import PartsEngineSales from "./components/Parts&Engines";
import { Routes, Route } from "react-router-dom";
import Service from "./components/Service";
import OtherBrands from "./components/OtherBrands";
import AboutUs from "./components/AboutUs";
import Home from "./components/Home";


const App = () => { 
  return ( 
  <div>  
<Routes>
  <Route path="/" element={<Home />} />
  <Route path="/PartsEngineSales" element={<PartsEngineSales />} />
  <Route path="/Service" element={<Service />} />
  <Route path="/OtherBrands" element={<OtherBrands />} />
  <Route path="/AboutUs" element={<AboutUs />} />
</Routes>
  </div>
   );

  };
export default App;